import * as layouts from "layouts"
import * as routing from "brandguard/routing"
import * as bgapprovals from "brandguard/display/approval"

export function upload(): JSX.Element {
	return (
		<bgapprovals.Container urlgen={routing.video.approval.upload}>
			<layouts.containers.flex
				flexDirection="column"
				height="100%"
				overflow="hidden"
				data-testid="video-brandguard-upload"
			>
				<bgapprovals.VideoActiveLink imageUrlgen={routing.image.approval.upload} documentUrlgen={routing.document.approval.upload} textUrlgen={routing.text.approval.upload} />
				<bgapprovals.navigation.VideosNav />
				<bgapprovals.videos.UploadDisplay />
			</layouts.containers.flex>
		</bgapprovals.Container>
	)
}

export function review(): JSX.Element {
	return (
		<bgapprovals.Container urlgen={routing.video.approval.review}>
			<layouts.containers.flex
				flexDirection="column"
				height="100%"
				overflow="hidden"
				data-testid="video-brandguard-review"
			>
				<bgapprovals.VideoActiveLink imageUrlgen={routing.image.approval.review} documentUrlgen={routing.document.approval.review} textUrlgen={routing.text.approval.review} />
				<bgapprovals.navigation.VideosNav />
				<bgapprovals.videos.ReviewDisplay />
			</layouts.containers.flex>
		</bgapprovals.Container>
	)
}

export function approved(): JSX.Element {
	return (
		<bgapprovals.Container urlgen={routing.video.approval.approved}>
			<layouts.containers.flex
				flexDirection="column"
				height="100%"
				overflow="hidden"
				data-testid="video-brandguard-approved"
			>
				<bgapprovals.VideoActiveLink imageUrlgen={routing.image.approval.approved} documentUrlgen={routing.document.approval.approved} textUrlgen={routing.text.approval.approved} />
				<bgapprovals.navigation.VideosNav />
				<bgapprovals.videos.ApprovedDisplay />
			</layouts.containers.flex>
		</bgapprovals.Container>
	)
}

export function rejected(): JSX.Element {
	return (
		<bgapprovals.Container urlgen={routing.video.approval.rejected}>
			<layouts.containers.flex
				flexDirection="column"
				height="100%"
				overflow="hidden"
				data-testid="video-brandguard-rejected"
			>
				<bgapprovals.VideoActiveLink imageUrlgen={routing.image.approval.rejected} documentUrlgen={routing.document.approval.rejected} textUrlgen={routing.text.approval.rejected} />
				<bgapprovals.navigation.VideosNav />
				<bgapprovals.videos.RejectedDisplay />
			</layouts.containers.flex>
		</bgapprovals.Container>
	)
}
